import { DropDownBox } from "devextreme-react/drop-down-box";

import TreeView from "devextreme-react/tree-view";
import { useRef, useState } from "react";

const TreeLookupEdit = ({
  defaultValue,
  dataSource,
  parentMember = "parent_id",
  displayMember = "name",
  valueMember = "id",
  children,
  onValueChanged,
}) => {
  const [opened, setOpened] = useState(false);
  const [value, setValue] = useState(defaultValue);
  const tree = useRef();

  const onChanged = (data) => {
    setValue(data);
    onValueChanged(data);
    setOpened(false);
  };
  const renderTree = () => {
    return (
      <TreeView
        width="auto"
        defaultValue={defaultValue}
        dataSource={dataSource}
        ref={tree}
        dataStructure="plain"
        expandedExpr="expanded"
        keyExpr={valueMember}
        displayExpr={displayMember}
        valueExpr={valueMember}
        showCheckBoxesMode="normal"
        parentIdExpr={parentMember}
        selectionMode="single"
        selectByClick={true}
        onItemClick={() => {}}
        onContentReady={(e) => e.component.selectItem(defaultValue)}
        onItemSelectionChanged={(e) =>
          onChanged(e.component.getSelectedNodeKeys())
        }
      />
    );
  };

  return (
    <DropDownBox
      value={value}
      valueExpr={valueMember}
      displayExpr={displayMember}
      deferRendering={false}
      showClearButton={true}
      dataSource={dataSource}
      contentRender={renderTree}
      opened={opened}
      dropDownOptions={{
        width: "auto",
        closeOnOutsideClick: true,
        onHiding: () => {
          setOpened(false);
        },
      }}
      width="100%"
      onValueChanged={(e) => onChanged(e.value)}
      onOptionChanged={(e) => {
        if (e.name === "opened") {
          setOpened(true);
        }
      }}
    >
      {children}
    </DropDownBox>
  );
};

export default TreeLookupEdit;
